import type { RestLink } from 'apollo-link-rest';
import EventProgress from './eventProgress';
import SubEvents from './subEvents';
import EventResponse from './eventResponse';
import ResultPredictions from './resultPredictions';
import SessionResponse from './sessionResponse';
import ParticipantSearch from './participantSearch';
import AwardsResponse from './awardsResponse';
import FullSubEvent from './subEventResponse';
import PhotosResponse from './photosResponse';
import ResultDetail from './resultDetailResponse';
import GallerySample from './gallerySampleResponse';
import SearchEventsResponse from './searchEventsResponse';
import StatisticsResponse from './statisticsResponse.ts';
import FinisherCertificateResponse from './finisherCertificateResponse';
import EventTemplateContentResponse from './eventTemplateContentResponse';
import ParticipantResult from './participantResult.ts';

export default {
  EventProgress,
  SubEvents,
  EventResponse,
  ResultPredictions,
  SessionResponse,
  ParticipantSearch,
  AwardsResponse,
  FullSubEvent,
  PhotosResponse,
  ResultDetail,
  GallerySample,
  SearchEventsResponse,
  StatisticsResponse,
  FinisherCertificateResponse,
  EventTemplateContentResponse,
  ParticipantResult,
} as RestLink.TypePatcherTable;
